/* Verschieben von Dialogen an der Titelleiste: reine Rechnung ohne DOM. */
export interface Box { left: number; top: number; width: number }
export interface Viewport { w: number; h: number }

/** Mindestanteil der Titelleiste, der sichtbar bleiben muss (Breite in Pixeln) und Höhe der Leiste */
export const KEEP_X = 80;
export const BAR_H = 28;

/** Begrenzt die Verschiebung (dx, dy) so, dass die Titelleiste im Fenster greifbar bleibt: oben nie außerhalb, seitlich mindestens KEEP_X sichtbar, unten mindestens die Leiste. */
export function clampDrag(box: Box, dx: number, dy: number, vp: Viewport): { x: number; y: number } {
  const minX = KEEP_X - (box.left + box.width), maxX = vp.w - KEEP_X - box.left;
  const minY = -box.top, maxY = vp.h - BAR_H - box.top;
  return { x: Math.min(maxX, Math.max(minX, dx)), y: Math.min(maxY, Math.max(minY, dy)) };
}
